import {
  getFactionBattleEndPresentation,
  isAfterBattleFactionPresentationEligible,
} from '../config/factionBattleEndPresentation';

const DEFAULT_DEV_PLAYER_FACTION = 'Remnants of Humanity';

function isDevNavigateStateFactionPresentationEligible(state) {
  const gameState = state?.gameState;
  const isWarEffortHQEnding =
    (state?.isWarEffort || !!gameState?.warEffortMissionId) &&
    (state?.fromWarEffortMissionOver === true
      || (gameState?.warEffortBattleType === 'enemy_hq' && state?.result === 'win'));
  const isExploreUnknownRun =
    !!(state?.exploreUnknownRun || gameState?.exploreUnknownMissionIndex != null);
  const isExploreUnknownHomecoming =
    isExploreUnknownRun && state?.exploreUnknownRunHomecoming === true;
  const isExploreUnknownLoss = isExploreUnknownRun && state?.result === 'loss';

  return isAfterBattleFactionPresentationEligible({
    isWarEffortHQEnding,
    isExploreUnknownHomecoming,
    isExploreUnknownLoss,
  });
}

/**
 * Dev-only: enrich AfterBattle navigation state with faction battle-end fields
 * required by resolvePlayerFactionFromBattleContext / faction presentation.
 *
 * @param {object} baseState
 * @param {{ playerFactionName?: string }} [options]
 * @returns {object}
 */
export function buildDevAfterBattleNavigateState(baseState, options = {}) {
  const result = baseState?.result;
  if (result !== 'win' && result !== 'loss') {
    return baseState;
  }
  if (!isDevNavigateStateFactionPresentationEligible(baseState)) {
    return baseState;
  }

  const playerFactionName =
    baseState.playerFactionName ?? options.playerFactionName ?? DEFAULT_DEV_PLAYER_FACTION;

  if (
    baseState.playerFactionName &&
    baseState.battleEndAssetSlug &&
    baseState.battleEndComponentFaction
  ) {
    return baseState;
  }

  const presentation = getFactionBattleEndPresentation(playerFactionName, result, {
    assetSlug: baseState.battleEndAssetSlug,
    componentFaction: baseState.battleEndComponentFaction,
  });

  return {
    ...baseState,
    playerFactionName,
    battleEndAssetSlug: presentation.assetSlug,
    battleEndComponentFaction: presentation.componentFaction,
  };
}
